<template>
  <div class="w-full flex items-center justify-center space-x-2 text-lg">
    <span>
      <slot name="title" />
    </span>
    <span
      class="font-bold"
      :class="{
        'text-secondary--1': isKids || isGuardian,
        'text-pets-tertiary-0': isPets
      }"
      @click.stop.prevent="linkClicked"
    >
      <slot name="link" />
    </span>
  </div>
</template>

<script setup>
import { isKids, isGuardian, isPets } from '@/comp/AppType'

const emit = defineEmits(['click'])
const linkClicked = () => emit('click')
</script>
